<template>
  <div class="notification" :class="{ ['bg-' + notification.variant]: true }">
    <span>{{ notification.text }}</span>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CNotificationBar",
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      timeout: null
    };
  },
  methods: {
    ...mapActions("notification", ["remove"])
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  mounted() {
    this.timeout = setTimeout(() => {
      this.remove(this.notification);
    }, this.notification.timeout || 2000);
  }
};
</script>

<style>
.notification-group {
  position: fixed;
  z-index: 999999;
  bottom: 0;
  right: 0;
  padding: 10px;
  display: flex;
  flex-direction: column-reverse;
}

.notification {
  /* background: #64a2ff; */
  color: #fff;
  border-radius: 5px;
  padding: 15px;
  margin-top: 5px;
  font-size: 0.8em;
}

.notification-enter-active {
  opacity: 0.8;
  transform: translate(100%);
  transition: 0.5s;
}

.notification-enter-to {
  opacity: 1;
  transform: translate(0);
}

.notification-leave-active {
  opacity: 1;
  transform: translate(0);
  transition: 0.5s;
}

.notification-leave-to {
  opacity: 0;
  transform: translate(100%);
}
</style>
